<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
	>
		<path
			d="M20 4C20 6.20914 18.2091 8 16 8C13.7909 8 12 6.20914 12 4C12 1.79086 13.7909 0 16 0C18.2091 0 20 1.79086 20 4Z"
			fill="#B9BABA"
		>
			<animate
				attributeName="fill"
				dur="800ms"
				:values="animate"
				begin="0"
				repeatDur="indefinite"
			/>
		</path>

		<path
			d="M32 16C32 18.2091 30.2091 20 28 20C25.7909 20 24 18.2091 24 16C24 13.7909 25.7909 12 28 12C30.2091 12 32 13.7909 32 16Z"
			fill="#B9BABA"
		>
			<animate
				attributeName="fill"
				dur="800ms"
				:values="animate"
				repeatDur="indefinite"
				begin="0.2"
			/>
		</path>

		<path
			d="M8 16C8 18.2091 6.20914 20 4 20C1.79086 20 0 18.2091 0 16C0 13.7909 1.79086 12 4 12C6.20914 12 8 13.7909 8 16Z"
			fill="#B9BABA"
		>
			<animate
				attributeName="fill"
				dur="800ms"
				:values="animate"
				repeatDur="indefinite"
				begin="0.6"
			/>
		</path>
		<path
			d="M20 28C20 30.2091 18.2091 32 16 32C13.7909 32 12 30.2091 12 28C12 25.7909 13.7909 24 16 24C18.2091 24 20 25.7909 20 28Z"
			fill="#B9BABA"
		>
			<animate
				attributeName="fill"
				dur="800ms"
				:values="animate"
				repeatDur="indefinite"
				begin="0.4"
			/>
		</path>
		<path
			d="M27.1854 10.0935C25.6584 11.6899 23.1263 11.7461 21.53 10.219C19.9336 8.69198 19.8774 6.15994 21.4045 4.56357C22.9315 2.9672 25.4635 2.91101 27.0599 4.43807C28.6563 5.96512 28.7125 8.49716 27.1854 10.0935Z"
			fill="#B9BABA"
		>
			<animate
				attributeName="fill"
				dur="800ms"
				:values="animate"
				repeatDur="indefinite"
				begin="0.1"
			/>
		</path>

		<path
			d="M27.5619 27.0599C26.0349 28.6563 23.5028 28.7125 21.9065 27.1854C20.3101 25.6584 20.2539 23.1263 21.781 21.53C23.308 19.9336 25.8401 19.8774 27.4364 21.4045C29.0328 22.9315 29.089 25.4635 27.5619 27.0599Z"
			fill="#B9BABA"
		>
			<animate
				attributeName="fill"
				dur="800ms"
				:values="animate"
				repeatDur="indefinite"
				begin="0.3"
			/>
		</path>

		<path
			d="M10.219 10.47C8.69198 12.0664 6.15994 12.1226 4.56357 10.5955C2.9672 9.06849 2.91101 6.53645 4.43807 4.94008C5.96513 3.34371 8.49716 3.28752 10.0935 4.81458C11.6899 6.34164 11.7461 8.87367 10.219 10.47Z"
			fill="#B9BABA"
		>
			<animate
				attributeName="fill"
				dur="800ms"
				:values="animate"
				repeatDur="indefinite"
				begin="0.7"
			/>
		</path>

		<path
			d="M10.5955 27.4364C9.06849 29.0328 6.53646 29.089 4.94009 27.5619C3.34372 26.0349 3.28753 23.5028 4.81458 21.9065C6.34164 20.3101 8.87367 20.2539 10.47 21.781C12.0664 23.308 12.1226 25.8401 10.5955 27.4364Z"
			fill="#B9BABA"
		>
			<animate
				attributeName="fill"
				dur="800ms"
				:values="animate"
				repeatDur="indefinite"
				begin="0.5"
			/>
		</path>
	</svg>
</template>

<script setup>
import { computed, toRefs } from 'vue'
const props = defineProps({
	color: {
		type: String,
	},
})

const { color } = toRefs(props)

const animate = computed(() => {
	return `${color.value || '#34617E'};#B9BABA`
})
</script>
